/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Attachment,
  CreateAttachmentRequest,
  ErrorResponse,
} from '../models/index';
import {
    AttachmentFromJSON,
    AttachmentToJSON,
    CreateAttachmentRequestFromJSON,
    CreateAttachmentRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface CreateAttachmentOperationRequest {
    createAttachmentRequest: CreateAttachmentRequest;
}

export interface DeleteAttachmentRequest {
    id: string;
}

export interface GetAttachmentByIdRequest {
    id: string;
}

export interface UpdateAttachmentRequest {
    id: string;
    createAttachmentRequest: CreateAttachmentRequest;
}

/**
 * 
 */
export class AttachmentsApi extends runtime.BaseAPI {

    /**
     * Create a new attachment
     * Create a new attachment
     */
    async createAttachmentRaw(requestParameters: CreateAttachmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Attachment>> {
        if (requestParameters['createAttachmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createAttachmentRequest',
                'Required parameter "createAttachmentRequest" was null or undefined when calling createAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/attachments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAttachmentRequestToJSON(requestParameters['createAttachmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentFromJSON(jsonValue));
    }

    /**
     * Create a new attachment
     * Create a new attachment
     */
    async createAttachment(requestParameters: CreateAttachmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Attachment> {
        const response = await this.createAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an attachment
     * Delete attachment
     */
    async deleteAttachmentRaw(requestParameters: DeleteAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/attachments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an attachment
     * Delete attachment
     */
    async deleteAttachment(requestParameters: DeleteAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAttachmentRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a list of all attachments
     * Get all attachments
     */
    async getAllAttachmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Attachment>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/attachments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AttachmentFromJSON));
    }

    /**
     * Retrieve a list of all attachments
     * Get all attachments
     */
    async getAllAttachments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Attachment>> {
        const response = await this.getAllAttachmentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an attachment by its ID
     * Get attachment by ID
     */
    async getAttachmentByIdRaw(requestParameters: GetAttachmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Attachment>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAttachmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/attachments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentFromJSON(jsonValue));
    }

    /**
     * Retrieve an attachment by its ID
     * Get attachment by ID
     */
    async getAttachmentById(requestParameters: GetAttachmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Attachment> {
        const response = await this.getAttachmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing attachment
     * Update attachment
     */
    async updateAttachmentRaw(requestParameters: UpdateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Attachment>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAttachment().'
            );
        }

        if (requestParameters['createAttachmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createAttachmentRequest',
                'Required parameter "createAttachmentRequest" was null or undefined when calling updateAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/attachments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAttachmentRequestToJSON(requestParameters['createAttachmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentFromJSON(jsonValue));
    }

    /**
     * Update an existing attachment
     * Update attachment
     */
    async updateAttachment(requestParameters: UpdateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Attachment> {
        const response = await this.updateAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
